module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "unique-opened": "",
      "default-active": _vm.$route.path
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c422f19", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c422f19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = wCnr
// module chunks = 101